import { Box, StackLayout } from '@leagueplatform/genesis-core';
import { Masonry } from '@leagueplatform/masonry';

export const AutomaticPaymentSetupMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '784px',
      marginBottom: '$two',
    }}
  >
    <Box style={{ width: '100%' }}>
      <Masonry rootNodeId="csb-autopay$root" />
    </Box>
  </StackLayout>
);
